<template>
  <div>
    <br><br><br>
    <div class="container">
      <div class="text-center mt-5">
        <h2 style="color: #4CAEF6" class="font-light">
            <span style="color: #0085de;">Cantado Terminales</span> 
        </h2>
        <hr>
        <div class="row justify-content-center" >
            <div class="col-md-2">
                <b-button  variant="primary" pill  :style="accion == 1 ? 'margin-top: 25px; width: 100%; background: #60CD31; border-color: #60CD31; color: #000;' :
                 'margin-top: 25px; width: 100%; background: #039cf3; border-color: #039cf3;  color: #fff;'" 
                size="sm"   @click="cambioBoton(1)">
                  <img :src="accion == 1 ? 'icon/avance.png' : 'icon/avance2.png'" style="width: 28px;">  <span style="margin-top: 10px;">Avance</span>
                </b-button>
            </div>
            <div class="col-md-2" v-if="user.perfiles[0].perfil.id == 7">
                <b-button  variant="primary" pill  :style="accion == 2 ? 'margin-top: 25px; width: 100%; background: #60CD31; border-color: #60CD31; color: #000;' :
                 'margin-top: 25px; width: 100%; background: #039cf3; border-color: #039cf3;  color: #fff;'" 
                size="sm" @click="cambioBoton(2)">
                   <img :src="accion == 2 ? 'icon/terminal.png' : 'icon/terminal2.png'" style="width: 22px;"> Registro Terminal
                </b-button>
            </div>
            <!-- <div class="col-md-2" v-if="user.perfiles[0].perfil.id == 7 || user.perfiles[0].perfil.id == 3">
                <button @click="cambioBoton(3)" type="button" class="btn-sm btn btn-primary position-relative" :style="accion == 3 ? 'border-radius: 18px; margin-top: 25px; width: 100%; background: #60CD31; border-color: #60CD31; color: #000;' :
                                                                                                      'border-radius: 18px; margin-top: 25px; width: 100%; background: #039cf3; border-color: #039cf3;  color: #fff;'" >
                    <img :src="accion == 3 ? 'icon/notificacion.png' : 'icon/notificacion2.png'" style="width: 28px;"> Notificaciones
                    <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger" v-if="user.perfiles[0].perfil.id == 7">
                        {{arrayComent.length}}
                    </span>
                </button> -->
                <!-- <b-button  variant="primary" pill  :style="accion == 3 ? 'margin-top: 25px; width: 100%; background: #60CD31; border-color: #60CD31; color: #000;' :
                 'margin-top: 25px; width: 100%; background: #039cf3; border-color: #039cf3;  color: #fff;'" 
                 size="sm" @click="cambioBoton(3)">
                   <img :src="accion == 3 ? 'icon/notificacion.png' : 'icon/notificacion2.png'" style="width: 28px;"> Notificaciones
                     <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                        99+
                        <span class="visually-hidden">unread messages</span>
                    </span>
                </b-button> -->
            <!-- </div> -->
            <div class="col-md-2">
                <b-button  variant="primary" pill  :style="accion == 4 ? 'margin-top: 25px; width: 100%; background: #60CD31; border-color: #60CD31; color: #000;' :
                 'margin-top: 25px; width: 100%; background: #039cf3; border-color: #039cf3;  color: #fff;'" 
                size="sm" @click="cambioBoton(4)">
                   <img :src="accion == 4 ? 'icon/contacto.png' : 'icon/contacto2.png'" style="width: 50px;"> Contacto
                </b-button>
            </div>
        </div>
      </div>
    </div>
    <br><br> 
    <template v-if="accion != 0">
        <div class="row justify-content-center" >
            <div class="col-md-5">
                <hr style="border-top: 5px solid #60CD31 !important;  opacity :0.8;">
            </div>
        </div>
        <div style="  margin-top: -12px; box-shadow: 0px 0px 10px 1px #AFAFAF; " id="fondo">
            <template v-if="accion == 1">
                <Grafico  v-if="user.perfiles[0].perfil.id == 7" ></Grafico>
                <GraficoGerente  v-if="user.perfiles[0].perfil.id == 3" ></GraficoGerente>
                <GraficoCoordinador  v-if="user.perfiles[0].perfil.id == 12" ></GraficoCoordinador>
                <GraficoSub  v-if="user.perfiles[0].perfil.id == 2" ></GraficoSub>
                <GraficoTrade  v-if="user.perfiles[0].perfil.id == 10 || user.perfiles[0].perfil.id == 6" ></GraficoTrade>
            </template>
            <template v-if="accion == 2">
                <Registro></Registro>
            </template>
            <template v-if="accion == 3">
                <Notificacion v-if="user.perfiles[0].perfil.id == 7"></Notificacion>
                <NotificaGerente v-if="user.perfiles[0].perfil.id == 3"></NotificaGerente>
            </template>
            <template v-if="accion == 4">
                <Contacto></Contacto>
            </template>
        </div>
    </template>
  </div>
</template>

<script>
import GraficoTrade from './GraficoTrade.vue';
import GraficoCoordinador from './GraficoCoordinador.vue';
import GraficoSub from './GraficoSub.vue';
import GraficoGerente from './GraficoGerente.vue';
import Grafico from './Grafico.vue';
import Registro from './Registro.vue';
import Notificacion from './Notificacion.vue';
import NotificaGerente from './NotificaGerente.vue';
import Contacto from './Contacto.vue';

export default {
  components: { Registro,  Notificacion, Contacto, Grafico, NotificaGerente, GraficoCoordinador, GraficoSub, GraficoGerente, GraficoTrade },
    name:"inicio",
    data() {
        return {
          isMobile: this.$mobile(),
          accion:1,
          loader:false,
          arrayComent:[]
        }
    },
    created(){
     this.$bus.$on("actualizaNot", () => {
         this.getNoti();
        });
    },
    computed: {
        user() {
           return this.$store.getters.getInfoUser;
        },
    },
    methods:{
        cambioBoton(id){
            this.accion = id;
        },
        getNoti(){
           var url= 'cantado/notificaEjecutivo?idpdv='+ this.user.id_pdv + '&axc=' +  this.user.mrt;
            this.$api.get(url).then(
                ({data}) => {
                    console.log(data);
                    this.arrayComent = data.data.comentario;  
                }
            );  
        },
    },
    mounted(){

        // this.getNoti();
    }
}
</script>
<style>
 #fondo{
     background-image: url('../../../public/fotos/fondo.png');
     width: 100%!important;
     /* background: rgb(233, 233, 233); */
    }
</style>